// Brief constants used across the wizard
export const SERVICE_AREAS = ["Local", "Regional", "National", "International"];

export const COMPETITIVE_ADVANTAGES = [
  "Family Owned","Veteran Owned","Minority Owned","Woman Owned","Faith Based",
  "Local Business","Eco Friendly","Luxury Service","Premium Quality","Fast Service",
  "Affordable Pricing","Award Winning","Licensed & Insured","24 Hour Service","Personalized Service",
];

export const IDEAL_CUSTOMERS = [
  "Children","Teenagers","Young Adults","Adults","Seniors","Families","Parents",
  "Business Owners","Churches","Schools","Nonprofits","General Consumers",
];

export const INCOMES = [
  "Under $50,000","$50,000 - $100,000","$100,000 - $250,000","$250,000+",
];

export const BRAND_PERSONALITY = [
  "Friendly","Honest","Trustworthy","Professional","Luxury","Innovative","Creative",
  "Fun","Exciting","Inspirational","Family Oriented","Community Focused","Faith Based",
  "Modern","Traditional","Caring","Bold","Reliable","Elegant","Premium",
];

export const SONG_PURPOSES = [
  "Commercial Jingle","Company Theme Song","Brand Anthem","Website Music",
  "Social Media Campaign","Product Launch","Event Promotion","Trade Show",
  "Radio Commercial","TV Commercial","Podcast Intro","YouTube Intro",
  "Employee Motivation","Customer Appreciation",
];

export const GENRES = [
  "Pop","Country","Rock","R&B","Hip Hop","Rap","Gospel","Contemporary Christian",
  "Blues","Jazz","Soul","Funk","Reggae","Latin","EDM","Folk","Acoustic","Cinematic",
  "Corporate Inspirational",
];

export const MOODS = [
  "Happy","Fun","Exciting","Inspirational","Motivational","Professional","Trustworthy",
  "Emotional","Heartfelt","Relaxing","Luxurious","Powerful","Patriotic","Spiritual",
  "Energetic","Uplifting",
];

export const ENERGY_LEVELS = [
  "Very Calm","Relaxed","Moderate","Upbeat","High Energy","Extremely Energetic",
];

export const TEMPOS = ["Slow","Moderate","Fast","Very Fast"];

export const VOCAL_GENDERS = [
  "Male","Female","Male & Female Duet","Group Vocals","Choir","Children's Voices",
  "Spoken Voice","Instrumental Only",
];

export const VOCAL_STYLES = [
  "Smooth","Powerful","Soulful","Country","Pop","Gospel","Contemporary",
  "Deep Voice","Warm Voice","Conversational","Energetic","Inspirational",
];

export const INSTRUMENTS = [
  "Acoustic Guitar","Electric Guitar","Piano","Keyboard","Organ","Drums","Percussion",
  "Violin","Cello","Strings","Trumpet","Saxophone","Harmonica","Banjo","Mandolin",
  "Ukulele","Synthesizers","Full Orchestra",
];

export const LYRICS_CONTENT = [
  "Business Name","Slogan","Products","Services","Mission Statement","Company History",
  "Customer Benefits","Community Involvement","Faith Values","Website","Phone Number",
  "Physical Address","Founder Story","Testimonials","Awards","Certifications",
];

export const CALL_TO_ACTION = [
  "Visit Website","Call Now","Visit Location","Book Appointment","Request Quote",
  "Shop Online","Learn More","Follow On Social Media","Download App","Contact Us",
];

export const SONG_LENGTHS = [
  "15 Seconds","30 Seconds","60 Seconds","90 Seconds","2 Minutes","3 Minutes","4 Minutes","5 Minutes",
];

export const VIDEO_ADDONS = [
  "No","Lyric Video","Promotional Video","AI Music Video","Slideshow Video","Social Media Video Package",
];

export const YEARS_DROPDOWN = (() => {
  const arr = [];
  const cur = new Date().getFullYear();
  for (let y = cur; y >= 1900; y--) arr.push(y);
  return arr;
})();

export const STEPS = [
  { key: "business", label: "Business Profile" },
  { key: "description", label: "Business Description" },
  { key: "audience", label: "Audience & Brand" },
  { key: "song", label: "Song & Music" },
  { key: "vocals", label: "Vocals & Lyrics" },
  { key: "video", label: "Final Details" },
];
